import { environment } from '../environment';

export const downloadTermsOfAgreementHref = `${environment.baseUrl}/media/documents/Положение_о_политике_безопасности_и_защиты_данных_пользователей_интерне.doc`;
